import { render, staticRenderFns } from "./BottleEdit.vue?vue&type=template&id=23bdb078&"
import script from "./BottleEdit.vue?vue&type=script&lang=js&"
export * from "./BottleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports